import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import useStore from "../../../../../context/useStore";
import AssignationLead from "../../../../common/CarteLead/AssignationLead";
import BarreAcces from "../../../../common/CarteLead/BarreAcces";
import "../../../../common/CarteLead/carteLead.scss";
import EnTeteCarte from "../../../../common/CarteLead/EnTeteCarte";
import MenuActionsLead from "../../../../common/CarteLead/MenuActionsLead";
import { Creee, Modifiee, MotifAbandon } from "../../../../common/CarteLead/MetaCarte";
import ProduitLead from "../../../../common/CarteLead/ProduitLead";
import Puce from "../../../../common/CarteLead/Puce";
import StatutLead from "../../../../common/CarteLead/StatutLead";
import usePanneauCarte from "../../../../common/CarteLead/usePanneauCarte";
import ZoneCommentaires from "../../../../common/CarteLead/ZoneCommentaires";
import ZoneTaches from "../../../../common/CarteLead/ZoneTaches";
import { LeadPageContext } from "../../useLeads";
import { LeadContext } from "../LeadContext";
import { extrasOnglets } from "./carte/extrasOnglets";
import ZoneContactDomi from "./carte/ZoneContactDomi";
import ZoneDevis from "./carte/ZoneDevis";
import ZoneSociete from "./carte/ZoneSociete";
import { exporterLeadJson } from "./exportLeadJson";
import useStatus from "./LeadStatus/useStatus";
import PanneauLeadEntreprise from "./panneau/PanneauLeadEntreprise";
import {
  DOCUMENT_TYPE_PAR_PRODUIT,
  ENTITY_REF_PAR_CATEGORIE,
  filtreCandidatsAssignation,
  lienDuLead,
  nomDuLead,
  ONGLETS_PAR_CATEGORIE,
  peutDeposerDevis,
  produitDuLead,
} from "./profilLead";
import useLeadItem from "./useLeadItem";

const queryString = require("query-string");

// Pastilles près du nom : siège ou établissement, demande finalisée, produit
// indisponible et demandes liées pour une entreprise ; « Particulier » pour DOMI.
const PucesLead = ({ lead, productCategory, ouvrir }) => {
  if (productCategory === "DOMI") {
    return (
      <Puce icone="fa-user" titre="Demande d'un particulier" className="la-puce--contour">
        Particulier
      </Puce>
    );
  }
  const etablissement = lead.establishment;
  const indisponible = lead.productData && lead.productData.PRODUCT_REASON_UNAVAILABLE;
  const nbLiees = lead.nbLinkedLeads || 0;
  return (
    <>
      {etablissement && (
        <Puce
          ton={etablissement.isHeadOffice ? "info" : "neutre"}
          icone="fa-building"
          titre={etablissement.isHeadOffice ? "Le lead porte sur le siège social" : "Le lead porte sur un établissement secondaire"}
        >
          {etablissement.isHeadOffice ? "Siège" : "Établissement"}
        </Puce>
      )}
      {lead.isFinalized && (
        <Puce ton="ok" icone="fa-check" titre="Demande finalisée par le client">
          Finalisée
        </Puce>
      )}
      {indisponible && (
        <Puce ton="danger" icone="fa-times" titre={`Produit non disponible ${indisponible}`}>
          Produit non disponible
        </Puce>
      )}
      {nbLiees > 0 && (
        <button
          type="button"
          className="la-puce la-puce--contour la-puce--bouton"
          title="Les autres demandes de la même société"
          onClick={() => ouvrir("liees")}
        >
          <i className="fa fa-link" aria-hidden="true" />
          {nbLiees} demande{nbLiees > 1 ? "s" : ""} liée{nbLiees > 1 ? "s" : ""}
        </button>
      )}
    </>
  );
};

// Carte d'un lead entreprise (/leads) ou DOMI (/leads-domi), construite avec
// le kit commun de la carte lead auto (components/common/CarteLead, maquette
// docs/maquettes/leads-entreprise-domi-refonte.html) : en-tête (produit, nom,
// pastilles, dates, statut, assignation, export), zones société ou contact,
// commentaires, tâches et devis, barre d'accès aux sections du panneau de
// détail. La couleur du statut borde la carte et remplit la tuile du produit.
const LeadItem = ({ data }) => {
  const { productCategory } = useContext(LeadPageContext);
  const { lead, actions } = useLeadItem();
  const { tasksByProduct, managers, contacts, fileTypes, myRole, panneau } = useContext(LeadContext);
  const location = useLocation();
  const [state] = useStore();
  const { inputsConfig, constants } = state;
  const { statusRef } = useStatus(lead.status);
  const panneauCarte = usePanneauCarte(panneau, lead.id);
  const { estOuvert } = panneauCarte;

  useEffect(() => {
    actions.initLead(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  // Lien profond d'une notification (?leadId=…) : la carte vient à l'écran.
  useEffect(() => {
    const parsed = queryString.parse(location.search, { arrayFormat: "bracket" });
    let tm = null;
    if (lead.id && parsed.leadId === lead.id) {
      tm = setTimeout(() => {
        const el = document.querySelector(`#leaditem${lead.id}`);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 1000);
    }
    return () => clearTimeout(tm);
  }, [lead.id, location.search]);

  // La carte du lead ouvert dans le panneau reste visible dans la liste.
  useEffect(() => {
    if (!estOuvert || !lead.id) return;
    const el = document.querySelector(`#leaditem${lead.id}`);
    if (!el) return;
    const r = el.getBoundingClientRect();
    if (r.top < 72 || r.bottom > window.innerHeight) el.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }, [estOuvert, lead.id]);

  if (!lead.id) return null;

  const ton = (statusRef && statusRef.color) || "primary";
  const produit = produitDuLead(lead, productCategory, constants.items);
  const nom = nomDuLead(lead, productCategory);
  const typeDevis = (fileTypes || []).find((f) => f.code === DOCUMENT_TYPE_PAR_PRODUIT[lead.productId]) || null;
  const puceType = <PucesLead lead={lead} productCategory={productCategory} ouvrir={panneauCarte.ouvrir} />;
  const exports = [
    {
      id: "json",
      icone: "fa-download",
      libelle: "Exporter en JSON",
      aide: "informations du lead",
      onClick: () => exporterLeadJson(lead, productCategory, inputsConfig, constants),
    },
  ];

  return (
    <article
      className={`la la-carte la-ton-${ton} ${estOuvert ? "la-carte--ouverte" : ""}`.trim()}
      id={`leaditem${lead.id}`}
      aria-labelledby={`la-nom-${lead.id}`}
    >
      <EnTeteCarte
        produit={<ProduitLead {...produit} />}
        idNom={`la-nom-${lead.id}`}
        nom={nom}
        lien={lienDuLead(lead, productCategory)}
        puces={puceType}
        meta={
          <>
            <Creee iso={lead.createdAt} />
            <Modifiee iso={lead.updatedAt} />
          </>
        }
        motif={<MotifAbandon lead={lead} />}
        actions={
          <>
            <StatutLead lead={lead} onUpdateStatus={actions.onUpdateStatus} />
            <AssignationLead
              leadId={lead.id}
              assignedTo={lead.assignedTo}
              managers={managers}
              onAssigner={(id) => actions.onUpdateAssignTo(id, Boolean(lead.assignedTo))}
              filtrerCandidat={filtreCandidatsAssignation(productCategory)}
            />
            <MenuActionsLead actions={exports} />
          </>
        }
      />
      <div className="la-carte__corps">
        {productCategory === "DOMI" ? (
          <ZoneContactDomi lead={lead} ouvrir={panneauCarte.ouvrir} />
        ) : (
          <ZoneSociete lead={lead} ouvrir={panneauCarte.ouvrir} />
        )}
        <ZoneCommentaires
          commentaires={lead.comments || []}
          contacts={contacts}
          onAjouter={actions.onAddComment}
          ouvrir={panneauCarte.ouvrir}
        />
        <ZoneTaches
          taches={lead.tasks || []}
          catalogue={tasksByProduct}
          onBasculer={actions.onUpdateTask}
          ouvrir={panneauCarte.ouvrir}
        />
        <ZoneDevis
          lead={lead}
          produit={produit}
          typeDevis={typeDevis}
          entityRef={ENTITY_REF_PAR_CATEGORIE[productCategory]}
          canUpload={peutDeposerDevis(myRole)}
          onDepose={actions.ajouterMedia}
        />
      </div>
      <BarreAcces onglets={ONGLETS_PAR_CATEGORIE[productCategory]} extra={extrasOnglets(lead)} nom={nom} panneauCarte={panneauCarte} />
      {estOuvert && <PanneauLeadEntreprise ton={ton} puceType={puceType} constants={constants.items} />}
    </article>
  );
};

export default LeadItem;
